import { call } from 'redux-saga/effects';

import { callAsyncRequest } from '@sagas/helpers';
import { resolution } from '@utils';

import { CheckValidateAddressType } from './types';
import resolveUnstoppableDomain from './unstoppable-domains';
import { getAddressValidation } from './validate-address';

function* checkRegularAddress(data: CheckValidateAddressType) {
  const { address, currency, network } = data;
  try {
    const isSupportedDomain = yield resolution.isSupportedDomain(address);
    if (isSupportedDomain) {
      const result = yield* callAsyncRequest(resolveUnstoppableDomain, address, currency);
      if (result) {
        const params = { address: result, currency, network, domain: address };
        yield call(getAddressValidation, params);
      }
    } else {
      const params = { address, currency, network, domain: '' };
      yield call(getAddressValidation, params);
    }
  } catch (error) {
    const params = { address, currency, network, domain: '' };
    yield call(getAddressValidation, params);
  }
}

export default checkRegularAddress;
